/**
 * @generated SignedSource<<1cc0f8340d365118c8b0f69a30f40fe2>>
 * @relayHash 3b5fad1a56c1598624b4b5ffdde44051
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4c049eefe56af2e3d93d69210c8f6fc06cdb796a19b009865dd5ce274d19afd1

import type { ConcreteRequest } from 'relay-runtime';
export type FolderOverviewChildrenContentQuery$variables = {
  ids: ReadonlyArray<string>;
};
export type FolderOverviewChildrenContentQuery$data = {
  readonly databaseContent: {
    readonly nodes: ReadonlyArray<{
      readonly history: {
        readonly contributors: {
          readonly publishers: {
            readonly users: ReadonlyArray<{
              readonly accountId?: string | null;
              readonly displayName: string | null;
              readonly profilePicture: {
                readonly path: string;
              } | null;
            } | null>;
          } | null;
        } | null;
        readonly lastUpdated: {
          readonly when: string | null;
        } | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
  readonly embedContent: {
    readonly nodes: ReadonlyArray<{
      readonly history: {
        readonly contributors: {
          readonly publishers: {
            readonly users: ReadonlyArray<{
              readonly accountId?: string | null;
              readonly displayName: string | null;
              readonly profilePicture: {
                readonly path: string;
              } | null;
            } | null>;
          } | null;
        } | null;
        readonly lastUpdated: {
          readonly when: string | null;
        } | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
  readonly folderContent: {
    readonly nodes: ReadonlyArray<{
      readonly history: {
        readonly contributors: {
          readonly publishers: {
            readonly users: ReadonlyArray<{
              readonly accountId?: string | null;
              readonly displayName: string | null;
              readonly profilePicture: {
                readonly path: string;
              } | null;
            } | null>;
          } | null;
        } | null;
        readonly lastUpdated: {
          readonly when: string | null;
        } | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
  readonly pageContent: {
    readonly nodes: ReadonlyArray<{
      readonly history: {
        readonly contributors: {
          readonly publishers: {
            readonly users: ReadonlyArray<{
              readonly accountId?: string | null;
              readonly displayName: string | null;
              readonly profilePicture: {
                readonly path: string;
              } | null;
            } | null>;
          } | null;
        } | null;
        readonly lastUpdated: {
          readonly when: string | null;
        } | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
  readonly slideContent: {
    readonly nodes: ReadonlyArray<{
      readonly history: {
        readonly contributors: {
          readonly publishers: {
            readonly users: ReadonlyArray<{
              readonly accountId?: string | null;
              readonly displayName: string | null;
              readonly profilePicture: {
                readonly path: string;
              } | null;
            } | null>;
          } | null;
        } | null;
        readonly lastUpdated: {
          readonly when: string | null;
        } | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
  readonly whiteboardContent: {
    readonly nodes: ReadonlyArray<{
      readonly history: {
        readonly contributors: {
          readonly publishers: {
            readonly users: ReadonlyArray<{
              readonly accountId?: string | null;
              readonly displayName: string | null;
              readonly profilePicture: {
                readonly path: string;
              } | null;
            } | null>;
          } | null;
        } | null;
        readonly lastUpdated: {
          readonly when: string | null;
        } | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
};
export type FolderOverviewChildrenContentQuery = {
  response: FolderOverviewChildrenContentQuery$data;
  variables: FolderOverviewChildrenContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = {
  "kind": "Variable",
  "name": "ids",
  "variableName": "ids"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "page"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "lastUpdated",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "when"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v6 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v8 = [
  {
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      {
        "concreteType": "History",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "concreteType": "Contributors",
            "kind": "LinkedField",
            "name": "contributors",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContributorUsers",
                "kind": "LinkedField",
                "name": "publishers",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
],
v9 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "folder"
  }
],
v10 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "whiteboard"
  }
],
v11 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "database"
  }
],
v12 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "embed"
  }
],
v13 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "slide"
  }
],
v14 = [
  {
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      {
        "concreteType": "History",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "concreteType": "Contributors",
            "kind": "LinkedField",
            "name": "contributors",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContributorUsers",
                "kind": "LinkedField",
                "name": "publishers",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FolderOverviewChildrenContentQuery",
    "selections": [
      {
        "alias": "pageContent",
        "args": (v2/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v8/*: any*/)
      },
      {
        "alias": "folderContent",
        "args": (v9/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v8/*: any*/)
      },
      {
        "alias": "whiteboardContent",
        "args": (v10/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v8/*: any*/)
      },
      {
        "alias": "databaseContent",
        "args": (v11/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v8/*: any*/)
      },
      {
        "alias": "embedContent",
        "args": (v12/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v8/*: any*/)
      },
      {
        "alias": "slideContent",
        "args": (v13/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v8/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FolderOverviewChildrenContentQuery",
    "selections": [
      {
        "alias": "pageContent",
        "args": (v2/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "alias": "folderContent",
        "args": (v9/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "alias": "whiteboardContent",
        "args": (v10/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "alias": "databaseContent",
        "args": (v11/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "alias": "embedContent",
        "args": (v12/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "alias": "slideContent",
        "args": (v13/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v14/*: any*/)
      }
    ]
  },
  "params": {
    "cacheID": "3b5fad1a56c1598624b4b5ffdde44051",
    "id": "4c049eefe56af2e3d93d69210c8f6fc06cdb796a19b009865dd5ce274d19afd1",
    "metadata": {},
    "name": "FolderOverviewChildrenContentQuery",
    "operationKind": "query",
    "text": "query FolderOverviewChildrenContentQuery($ids:[ID!]!){pageContent:content(ids:$ids,type:\"page\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},folderContent:content(ids:$ids,type:\"folder\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},whiteboardContent:content(ids:$ids,type:\"whiteboard\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},databaseContent:content(ids:$ids,type:\"database\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},embedContent:content(ids:$ids,type:\"embed\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},slideContent:content(ids:$ids,type:\"slide\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}}}"
  }
};
})();

(node as any).hash = "47e4e127b7c7f393d655d6799a3ed4a3";

export default node;
